import * as React from 'react'
import { Intent, Button } from '@blueprintjs/core'
import { VALID_POLL_STATUSES } from './constants'
import ListingStates from '../../../constants/listings/ListingStates'

interface Props {
  isHidden: boolean
  listingState: string
  changesMade: boolean
  isListing: boolean
  onSaveAndList: () => void
  onSave: (showSuccess: boolean) => void
}

export const FooterActionButtons = ({
  isHidden,
  listingState,
  changesMade,
  isListing,
  onSaveAndList,
  onSave
}: Props): JSX.Element => {
  if (isHidden) return null

  if ([ListingStates.LISTED.id, ListingStates.MODIFY_FAILED.id, ListingStates.MODIFYING.id].includes(listingState)) {
    return (
      <div className="footer-action-buttons">
        <Button
          onClick={onSaveAndList}
          intent={Intent.PRIMARY}
          disabled={VALID_POLL_STATUSES.includes(listingState) || !changesMade}
          loading={isListing}
        >
          Save listing
        </Button>
      </div>
    )
  }

  return (
    <div className="footer-action-buttons">
      <Button
        className="save"
        onClick={onSaveAndList}
        intent={Intent.PRIMARY}
        disabled={VALID_POLL_STATUSES.includes(listingState)}
        loading={isListing}
      >
        Save and {listingState === ListingStates.RELISTING_FAILED.id ? 'relist' : 'list'}
      </Button>
      <Button
        onClick={() => onSave(true)}
        intent={Intent.PRIMARY}
        minimal
        disabled={VALID_POLL_STATUSES.includes(listingState)}
        loading={isListing}
      >
        Save
      </Button>
    </div>
  )
}
